
import { Component, Vue } from "vue-property-decorator";
import SvgIcon from "@/components/custom/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
class TerminosCondiciones extends Vue {}
export default TerminosCondiciones;
